export const getImagePath = (imageName) => {
  return `/images/portfolio/${imageName}`;
};


